import React, { useState } from 'react';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage, db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

function AddListing() {
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [category, setCategory] = useState('');
  const [sex, setSex] = useState('');
  const [traits, setTraits] = useState('');
  const [origin, setOrigin] = useState('');
  const [producer, setProducer] = useState('');
  const [birth, setBirth] = useState('');
  const [weight, setWeight] = useState('');
  const [proven, setProven] = useState('');
  const [diet, setDiet] = useState('');
  const [shipping, setShipping] = useState('');
  const [paymentMethods, setPaymentMethods] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Choose a file first!");

    const filename = `listings/${Date.now()}-${file.name}`;
    const storageRef = ref(storage, filename);

    try {
      await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(storageRef);
      setUrl(downloadURL);

      // Add listing data to Firestore
      await addDoc(collection(db, 'listings'), {
        title,
        description,
        price,
        category,
        sex,
        traits,
        origin,
        producer,
        birth,
        weight,
        proven,
        diet,
        shipping,
        paymentMethods,
        imageUrl: downloadURL,
        timestamp: new Date()
      });

      alert("Listing added successfully!");
      // Clear form
      setTitle('');
      setDescription('');
      setPrice('');
      setCategory('');
      setSex('');
      setTraits('');
      setOrigin('');
      setProducer('');
      setBirth('');
      setWeight('');
      setProven('');
      setDiet('');
      setShipping('');
      setPaymentMethods('');
      setFile(null);
    } catch (err) {
      console.error("Upload failed", err);
      alert("Upload failed: " + err.message);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Add Listing</h2>
      <form onSubmit={handleSubmit}>
        <div><label>Title:</label><br /><input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required /></div>
        <div><label>Description:</label><br /><textarea value={description} onChange={(e) => setDescription(e.target.value)} required /></div>
        <div><label>Price:</label><br /><input type="number" value={price} onChange={(e) => setPrice(e.target.value)} required /></div>
        <div><label>Category:</label><br /><input type="text" value={category} onChange={(e) => setCategory(e.target.value)} required /></div>
        <div><label>Sex:</label><br /><input type="text" value={sex} onChange={(e) => setSex(e.target.value)} /></div>
        <div><label>Traits:</label><br /><input type="text" value={traits} onChange={(e) => setTraits(e.target.value)} /></div>
        <div><label>Origin:</label><br /><input type="text" value={origin} onChange={(e) => setOrigin(e.target.value)} /></div>
        <div><label>Produced By:</label><br /><input type="text" value={producer} onChange={(e) => setProducer(e.target.value)} /></div>
        <div><label>Birth Year:</label><br /><input type="text" value={birth} onChange={(e) => setBirth(e.target.value)} /></div>
        <div><label>Weight (g):</label><br /><input type="number" value={weight} onChange={(e) => setWeight(e.target.value)} /></div>
        <div><label>Proven:</label><br /><input type="text" value={proven} onChange={(e) => setProven(e.target.value)} /></div>
        <div><label>Diet:</label><br /><input type="text" value={diet} onChange={(e) => setDiet(e.target.value)} /></div>
        <div><label>Shipping Cost:</label><br /><input type="text" value={shipping} onChange={(e) => setShipping(e.target.value)} /></div>
        <div><label>Payment Methods:</label><br /><input type="text" value={paymentMethods} onChange={(e) => setPaymentMethods(e.target.value)} /></div>
        <div><label>Image:</label><br /><input type="file" onChange={handleFileChange} required /></div>
        <button type="submit">Submit Listing</button>
      </form>
      {url && (
        <div>
          <p>Uploaded Image URL:</p>
          <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
        </div>
      )}
    </div>
  );
}

export default AddListing;
